import Env from '../base/env'
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import easesCustom from '../fx/CustomEases';

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.tags = this.DOM.view.querySelectorAll('.fxTag');
    this.DOM.tagsRandom =  gsap.utils.shuffle(gsap.utils.toArray(this.DOM.tags))
    this.DOM.separator = this.DOM.view.querySelector('.fxSeparator');
    this.DOM.reveal = this.DOM.view.querySelector('.fxReveal');
    //! Fns
    setTimeout(() => {
      this._fx()
    }, Env.timingDelayFx);
  }

  _fx()
  {
    this.animate()
    this.reveal()
  }

  animate()
  {
    this.animation = gsap.timeline()

    this.animation
    .add([
      gsap.fromTo(
        this.DOM.tagsRandom,
        {
          autoAlpha:0
        },
        {
          autoAlpha:1,
          y:0,
          ease:easesCustom.cubic,
          duration:.8,
          stagger:.1
        }
      ),
      gsap.fromTo(
        this.DOM.separator,
        {
          transformOrigin:'left top',
          scaleX:0
        },
        {
          scaleX:1,
          ease:easesCustom.quart,
          duration:.7
        }
      )
    ]).add([
      gsap.fromTo(
        this.DOM.reveal,
        {
          autoAlpha:0,
          y:20
        },
        {
          autoAlpha:1,
          y:0,
          duration:1,
          ease:easesCustom.cubic
        }
      )
    ],'-=.7')

  }

  reveal()
  {
    const offsetStart = (Env.mobileCSS)?'top 80%':'top 50%';
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:offsetStart
    })
  }

  unmount()
  {
    this.st.kill(true)
  }

}
